<template>
    <transition name="fade">
        <div class="WebsiteDialogue" v-show="websiteDialogueVisible">
            <div class="wd-container">
                
                <!-- Toolbar -->
                <div class="wd-bar">
                    <p class="wd-bar-name">{{ $t(title) }}</p>
                    <div class="wd-bar-buttons">  
                        <!-- <md-button class="md-icon-button" @click="openLink()">
                            <OpenInNewIcon class="openInNewIcon"/>
                        </md-button> -->
                        <md-button class="md-icon-button" @click="toggleWebsiteDialogue()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- PDF -->
                <vue-pdf-embed class="wd-iframe" id="wd-pdf" v-if="type == 'pdf'" :source="url" :height="pdfHeight"/>
                
                <!-- Website -->
                <iframe class="wd-iframe" id="wd-website" v-if="type == 'web'" :src="url" frameborder="0"/>

                <!-- Image -->
                <img class="wd-image wd-iframe" v-if="type == 'image'" :src="url" alt="">

                <!-- Video -->
                <video class="wd-image wd-iframe" id="wd-video" controls autoplay v-if="type == 'video'" :src="url"></video>

                <!-- pdfselection -->
                <div class="wd-documents" v-if="type == 'pdfselection'">
                    <div v-for="document in successStories" :key="document.title" class="wd-document" @click="openURL(publicPath + '/media/Venjakob-Messe-2/pdfs/' + $t(document.url))">
                        <img class="wd-document-icon" :src="publicPath + '/media/Venjakob-Messe-2/icons/icDocuments_white.svg'" alt="">
                        <div class="wd-document-title">{{ $t(document.title) }} <br> SUCCESS STORY</div>
                        <div class="wd-document-description">{{ $t(document.description) }}</div>
                        <div class="wd-document-link">{{ $t('Dokument ansehen ➝') }}</div>
                    </div>
                </div>

                <!-- praxisvorträge -->
                <div class="wd-documents" v-if="type == 'praxisvorträge'">
                    <div v-for="document in praxisvorträge" :key="document.title" class="wd-document" @click="openURL(publicPath + $t(document.url))">
                        <img class="wd-document-icon" :src="publicPath + '/media/Venjakob-Messe-2/icons/play.svg'" alt="">
                        <div class="wd-document-title">{{ $t(document.title)}}</div>
                        <img class="wd-document-image" :src="publicPath + '/media/Venjakob-Messe-2/thumbnails/' + document.thumbnail" alt="">
                        <div class="wd-document-link">{{ $t('Video ansehen ➝') }}</div>
                    </div>
                </div>
            </div>         

        </div>  
    </transition>
</template>

<style>
    .WebsiteDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 6;
    }
    .wd-container{
        background: radial-gradient(#dbdbdb, #ffffff);
        position: absolute;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 90%;
        height: 90%;
    }

    /* Toolbar */
    .wd-bar{
        display: flex;
        position: relative;
        height: 40px;
        background: white;
    }
    .wd-bar-name{
        width: 100%;
        color: rgb(82, 82, 82);
        text-align: center;
        margin: auto 0;
        font-size: 20px;
        font-weight: bold;
    }
    .wd-bar-close{
        background: var(--primaryColor) !important;
        position: absolute;
        right: 0;
        padding: 5px;
        border-radius: 0;
        margin-right: 0;
    }
    .wd-bar-close::before, .wd-bar-back::before{
        border-radius: 0;
    }
    .material-design-icon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: white;
        height: 2.5em;
        width: 2.5em;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
        margin-left: 0;
    }

    /* Website */
    .WebsiteDialogue .wd-iframe{
        width: 100%;
        height: calc(100% - 37px);
        overflow-x: hidden;
        border-radius: 0px 0px 10px 10px;
    }

    /* PDF */
    .WebsiteDialogue .vue-pdf-embed > div{
        display: flex;
        justify-content: center;
    }
    .WebsiteDialogue .textLayer{
        display: none;
    }
    .WebsiteDialogue .annotationLayer{
        display: none;
    }

    /* Image */
    .wd-image{
        object-fit: contain;
    }

    /* Icons */
    .WebsiteDialogue .material-design-icon {
        height: 2.2em;
        width: 2.2em;
    }
    .WebsiteDialogue .material-design-icon > .material-design-icon__svg {
        fill: black !important;
        height: 2.2em;
        width: 2.2em;
    }
    .WebsiteDialogue .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }

    /* Success Stories */
    .wd-documents{
        width: 100%;
        height: calc(100% - 37px);
        overflow-x: hidden;
        border-radius: 0px 0px 10px 10px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .wd-document{
        width: 420px;
        height: 360px;
        padding-left: 25px;
        border-radius: 7px;
        background: white;
        filter: drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.4));
        overflow: hidden;
        margin: 40px;
        transition: transform .4s ease;
        cursor: pointer;
    }
    .wd-document:hover{
        transform: scale(1.03);
    }
    .wd-document-title{
        margin-bottom: 15px;
        padding-right: 20px;
        font-weight: bold;
        font-size: 26px;
        line-height: 30px;
    }
    .wd-document-description{
        font-size: 18px;
        margin-bottom: 25px;
        padding-right: 70px;
    }
    .wd-document-image{
        width: calc(100% - 20px);
        height: 200px !important;
        object-fit: cover;
        margin-bottom: 20px;
    }
    .wd-document-link{
        color: var(--primaryColor);
        cursor: pointer;
        transition: color .2s ease;
    }
    .wd-document-link:hover{
        color: #667c96;
    }
    .wd-document-icon{
        height: 60px;
        width: 60px;
        display: block;
        margin-left: auto;
        background: var(--primaryColor);
        padding: 10px;
        border-radius: 0px 0px 0px 7px;
        margin-bottom: 10px;
    }

    /* Close Icon */
    .material-design-icon.closeIcon{
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon > .material-design-icon__svg {
        fill: rgb(252, 113, 113) !important;
        height: 2.5em;
        width: 2.5em;
    }

    /* open in new Tab Icon */
    .material-design-icon.openInNewIcon {
        fill: black;
        height: 1.9em;
        width: 1.9em;
    }
    .material-design-icon.openInNewIcon > .material-design-icon__svg {
        height: 1.9em;
        width: 1.9em;
    }

    /* Mobile */
    @media (max-device-width: 900px){
        .wd-screen{
            z-index: 99;
        }
    }
</style>
    
<script>
import {mapMutations} from 'vuex';

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
    components: {CloseIcon, OpenInNewIcon, VuePdfEmbed},
    data: function () {
        return {
		    publicPath: process.env.BASE_URL,
            websiteDialogueVisible: false,
            url: "",
            type: "web",
            pdfHeight: 1000,
            isFormular: false,
            title: "",

            successStories: [
                {
                    title: "GILJE TRE",
                    description: "Vollautomatische Lackierung von Fenstereinzelteilen ermöglicht schnelle und flexible Produktion",      
                    url: "deutsch1.pdf"             
                },
                {
                    title: "RWD SCHLATTER AG",
                    description: "Flexible Oberflächenbeschichtung im Chargenbetrieb",       
                    url: "deutsch2.pdf"            
                },
                {
                    title: "JELD-WEN",
                    description: "Flexible Kantenspritzlackieranlage für präzise und umweltfreundliche Türkantenlackierung",             
                    url: "deutsch3.pdf"     
                },
                {
                    title: "GARANT TÜREN UND ZARGEN GMBH",
                    description: "Ressourcenschonende Türenbeschichtungslinie",             
                    url: "deutsch4.pdf"     
                },
                {
                    title: "ETS TREPPENBAU UND SCHREINEREI GMBH",
                    description: "Automatische Treppen-Beschichtungsanlage",             
                    url: "deutsch5.pdf"     
                },
                {
                    title: "NOLTE KÜCHEN",
                    description: "Spritzlackierlinie zur Beschichtung und Trocknung matter Oberflächen",             
                    url: "nolteKuechen.pdf"     
                },
            ],

            praxisvorträge: [
                {
                    title: "Objekttüren nach Maß",
                    thumbnail: "Objekttüren nach Maß.jpg",
                    url: "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Stender - Deutsch.mp4"             
                },
                {
                    title: "Automatisierungslösung in der Fördertechnik",
                    thumbnail: "Automatisierungslösung in der Fördertechnik.jpg",
                    url: "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Runschke - Deutsch.mp4"             
                },
                {
                    title: "Individuelle Beschichtungsmethoden für Möbel im Spritzverfahren",
                    thumbnail: "Individuelle Beschichtungsmethoden für Möbel im Spritzverfahren.jpg",
                    url: "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Feldmann - Deutsch.mp4"             
                },
                {
                    title: "Excimertechnologie im Spritzverfahren",
                    thumbnail: "Excimertechnologie im Spritzverfahren.jpg",
                    url: "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Maschinenvorführung VEN SPRAY PERFECT - Deutsch.mp4"             
                }
            ]
        }
    }, 
    watch: {
        type(){
            setTimeout(() => {
                if(this.type == "pdf")
                    this.pdfHeight = document.getElementById("wd-pdf").clientHeight;
            }, 0);
        }
    },
	methods: {
        ...mapMutations(["setDialogueOpen"]),
        openURL(url){
            window.open(url, '_blank').focus();
        },

        // Toggles visibility of this dialogue
        toggleWebsiteDialogue(){
            this.websiteDialogueVisible=!this.websiteDialogueVisible;
            this.setDialogueOpen(this.websiteDialogueVisible);

            if(!this.websiteDialogueVisible){
                let iframe = document.getElementById("wd-website");
                if(iframe)
                    iframe.onload = null;

                this.url = "";
                this.type = "web";
                this.isFormular = false;
            }        
        },

        // Opens Link in separate window
        openLink(){
            window.open(this.url, '_blank');
        },

        // Displays this dialogue and changes url
        initDialogue: function(e) {
            this.url = e.detail.url; 
            this.isFormular = e.detail.isFormular;
            this.title = e.detail.title;

            if(this.url == "pdfselection")
                this.type = "pdfselection";

            if(this.url == "praxisvorträge")
                this.type = "praxisvorträge";

            if(this.url.includes('.jpg') || this.url.includes('.png') || this.url.includes('.webp'))
                this.type = "image";
            
            if(this.url.includes('.mp4')){
                this.type = "video";
                setTimeout(() => { document.getElementById("wd-video").volume = 0.3; }, 0);
            }
            
            if(this.url.includes(".pdf"))
                this.type = "pdf";
            
            if(this.isFormular){
                setTimeout(() => {
                    let initialLoaded = false;

                    document.getElementById("wd-website").onload = () => {
                        if(initialLoaded){
                            // Safe in cookies that user loggedin
                            localStorage.setItem('venjakob-tectogether', true);

                            // Open Content
                            this.type = e.detail.realURL;
                            console.log(this.type);

                            if(this.type == "pdfselection"){
                                this.title = "Venjakob Success Stories";
                            }
                            if(this.type == "Ständer"){
                                this.type = "video";
                                this.url = this.praxisvorträge[0].url;
                                this.title = this.praxisvorträge[0].title;
                            }
                            if(this.type == "Runschke"){
                                this.type = "video";
                                this.url = this.praxisvorträge[1].url;
                                this.title = this.praxisvorträge[1].title;
                            }
                            if(this.type == "Feldmann"){
                                this.type = "video";
                                this.url = this.praxisvorträge[2].url;
                                this.title = this.praxisvorträge[2].title;
                            }
                            if(this.type == "Feldmann2"){
                                this.type = "video";
                                this.url = this.praxisvorträge[3].url;
                                this.title = this.praxisvorträge[3].title;
                            }
                        }   
                        initialLoaded = true;
                    };
                }, 0);
            }


            if(this.url == "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Deutsch.mp4")
                this.title = "Venjakob Betriebsrundgang";
            if(this.url == "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Englisch.mp4")
                this.title = "Venjakob Betriebsrundgang";
            if(this.url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442295")
                this.title = 'Virtual Showroom "Akkustikdeckenplatten"';
            if(this.url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442311")
                this.title = 'Virtual Showroom "Fenstereinzelteilbeschichtung"';
            if(this.url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442291")
                this.title = 'Virtual Showroom "Flexible Beschichtungen"';
            if(this.url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442303")
                this.title = 'Virtual Showroom "Hochleistungsbeschichtung"';

            this.toggleWebsiteDialogue();
        },
    },

    // Add Eventlistener that displays and initializes this dialogue. Event gets fired inside URLButton component
    mounted: function(){
        window.addEventListener('openURL',this.initDialogue);
    }
}

</script>